<template>
  <div class="container">
    <Title :title="{name: '采购申请', path:'/item/puchase'}"></Title>
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">
        <el-divider content-position="left">采购申请单</el-divider>
        <el-form-item label="采购类型" prop="purchaseType">
          <el-radio-group v-model="ruleForm.purchaseType">
            <el-radio label="1">办公耗材</el-radio>
            <el-radio label="2">固定资产</el-radio>
            <el-radio label="3">项目采购</el-radio>
            <el-radio label="4">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="申请到货时间" prop="arrivalTime">
          <el-date-picker
            v-model="ruleForm.arrivalTime"
            placeholder="请选择到货时间"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <div v-if="ruleForm.purchaseType === '3'">
          <el-form-item label="项目名称" prop="projectId">
            <el-select v-model="ruleForm.projectId" placeholder="请选择报备项目" filterable>
              <el-option
                  v-for="item in allSysProject"
                  :key="item.projectId"
                  :label="item.projectName"
                  :disabled="item.projectState === 6"
                  :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="紧急程度" prop="urgencyLevel">
          <el-radio-group v-model="ruleForm.urgencyLevel">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">加急</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="申购理由" prop="purchaseReason">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="ruleForm.purchaseReason"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="2" maxlength="100" show-word-limit v-model="ruleForm.remarks"></el-input>
        </el-form-item>
        <el-divider content-position="left">清单</el-divider>
        <el-form-item label="物品名称" prop="itemName">
          <el-input v-model="ruleForm.itemName"></el-input>
        </el-form-item>
        <el-form-item label="物品数量" prop="itemNumber">
          <el-input-number v-model="ruleForm.itemNumber" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="submit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import {requestProjectAllGet, requestPurchaseApply, requestApplyDetail} from "@/api";
export default {
  components: {Title},
  name: "PurchaseApply",

  data() {
    return {
      submitShow: "true",
      allSysProject: [],
      ruleForm : {
        purchaseType: "1",
        arrivalTime: "",
        projectId: "",
        urgencyLevel: "1",
        remarks: "",
        purchaseReason: "",
        payType: "1",
        itemName: "",
        itemNumber: "",
        factory: "",
        model: "",
        price: "",
        purchaseId: ""
      },
      rules: {
        purchaseType: [
          {required: true, message: '请填写采购类型', trigger: 'blur'}
        ],
        arrivalTime: [
          {required: true, message: '请填写到货时间', trigger: 'blur'}
        ],
        projectId: [
          {required: true, message: '请填写采购项目', trigger: 'blur'}
        ],
        urgencyLevel: [
          {required: true, message: '请填写紧急程度', trigger: 'blur'}
        ],
        purchaseReason: [
          {required: true, message: '请填写采购理由', trigger: 'blur'}
        ],
        itemName: [
          {required: true, message: '请填写物品名称', trigger: 'blur'}
        ],
      }
    }
  },
  created() {
    this.loadSysProjectData()
    this.param = {
      applyId: this.$route.query.applyId,
      applyServiceId: this.$route.query.applyServiceId,
      applyType: this.$route.query.applyType
    }
    if (this.param.applyId || this.param.applyServiceId || this.param.applyType) {
      this.reapply = true
      this.disabled = false
      this.getObject()
    }
  },
  methods: {
    async loadSysProjectData() {
      let res = await requestProjectAllGet();
      if (res.code === 200) {
        this.allSysProject = res.object;
      } else {
        this.$message.error("获取项目列表失败")
      }
    },
    submit() {
      this.$refs['ruleForm'].validate((isPass) => {
        if (isPass) {
          this.submitShow = false
          let param = {
            purchaseType: this.ruleForm.purchaseType,
            arrivalTime: this.ruleForm.arrivalTime,
            urgencyLevel: this.ruleForm.urgencyLevel,
            remarks: this.ruleForm.remarks,
            purchaseReason: this.ruleForm.purchaseReason,
            itemNumber: this.ruleForm.itemNumber,
            itemName: this.ruleForm.itemName
          }
          if (this.ruleForm.purchaseType === '3') {
            param.projectId = this.ruleForm.projectId
          }
          if (this.reapply) {
            param.applyId = this.param.applyId
            param.purchaseId = this.ruleForm.purchaseId
            param.reapply = this.reapply
          }
          requestPurchaseApply(param).then(res => {
            if (res.code === 200) {
              this.submitShow = true
              this.$refs['ruleForm'].resetFields()
              if (this.reapply) {
                this.$router.push({query: {}})
              }
              this.$message.success(res.msg)
            } else {
              this.submitShow = true
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.submitShow = true
            this.$message.error(`服务开小差了${err}`)
          })
        }
      })
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        if (res.object) {
          let detail = res.object.detail
          for (let key in this.ruleForm) {
            if (detail[key] != null) {
              this.ruleForm[key] = detail[key].toString()
            } else {
              this.ruleForm[key] = detail[key]
            }
          }
          if (this.ruleForm.projectId) {
            this.ruleForm.projectId = parseInt(this.ruleForm.projectId)
          }
        }
      } else {
        this.$message.error(res.msg);
      }
    },
  }
}
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
  background-color: #F2F6FC;
}
</style>
